import {
    Icon,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";


export interface SideBarItemProps {
  logoSrc: any;
  label: string;
  path: string;
  shouldShowLabel?: boolean;
  disabled?: boolean;
}
const SideBarItem: React.FC<SideBarItemProps> = ({
  logoSrc,
  label,
  path,
  shouldShowLabel = true, disabled = false,
}) => {
  const { pathname } = useLocation();

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(pathname === `/dashboard/${path}`);
  }, [pathname, path]);

  return (
    <ListItem
        id={`menu-list-item-${path}`} disablePadding
        sx={{
            display: "block",
            mt: "12px",
        }}
    >
      <ListItemButton
        disabled={disabled}
        component={Link}
        to={`/dashboard/${path}`}
        selected={selected}
        sx={{
            border: "unset!important",
            minHeight: 48,
            justifyContent: shouldShowLabel ? "initial" : "center",
            px: 2,
            '&.Mui-selected': {
                borderRadius: "0 33px 33px 0"
            },
        }}
      >
        <ListItemIcon
          sx={{
              borderRadius: "6px",
              backgroundColor: "rgba(84, 189, 193, 0.3)",
              p: 1,
              minWidth: 0,
              mr: shouldShowLabel ? "1px" : "auto",
              justifyContent: "center",
              marginLeft:"4px",
          }}
        >
          <Tooltip placement="right" title={label}>
              <Icon color="primary">{logoSrc}</Icon>
          </Tooltip>

        </ListItemIcon>
        <ListItemText
          primary={label}
          sx={{
              opacity: shouldShowLabel ? 1 : 0,
              transition: 'opacity 0.6s ease-in-out',
              ml: 1,
        }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default SideBarItem;

